import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { Role } from '@niko-crm/ui';
import { RoleActions } from './role.actions';

export interface RoleState extends EntityState<Role> {
  total: number;
  page: number;
  limit: number;
  loading: boolean;
  error: string | null;
}

export const rolesAdapter: EntityAdapter<Role> = createEntityAdapter<Role>();

const initialState: RoleState = rolesAdapter.getInitialState({
  total: 0,
  page: 1,
  limit: 20,
  loading: false,
  error: null,
});

export const roleReducer = createReducer(
  initialState,
  on(RoleActions.loadRoles, (state) => ({ ...state, loading: true, error: null })),
  on(RoleActions.loadRolesSuccess, (state, { result }) =>
    rolesAdapter.setAll(result.data, {
      ...state,
      total: result.total,
      page: result.page,
      limit: result.limit,
      loading: false,
    })
  ),
  on(RoleActions.loadRolesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(RoleActions.createRoleSuccess, (state, { role }) => rolesAdapter.addOne(role, state)),
  on(RoleActions.cloneRoleSuccess, (state, { role }) => rolesAdapter.addOne(role, state)),
  on(RoleActions.updateRoleSuccess, (state, { role }) =>
    rolesAdapter.updateOne({ id: role.id, changes: role }, state)
  ),
);

export const rolesFeature = createFeature({
  name: 'roles',
  reducer: roleReducer,
});
